<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
      :useFieldInfo="true"
      :typeslabel="{
        date: '등록일',
      }"
      :types="['field_name', '부서명_과', 'com_name', 'manager_name', 'writer_name', 'date']"
      :options="[
        { type: 'text', label: '작성자', readonly: true },
        { type: 'daterang', label: '사업기간' },
      ]"
    />

    <!-- 회사 정보 -->
    <div class="mb-4">
      <div>
        <h5><i class="dot"></i>회사 정보</h5>
      </div>
    </div>
    <div class="writeGridContainer">
      <div>
        <div>회사명</div>
        <div>
          <p v-if="isPrint" class="print-input">{{ form.회사명 }}</p>
          <ml-input v-else class="w-full" v-model="form.회사명" :readonly="board.readonly" />
        </div>
      </div>
      <div>
        <div>사업자등록번호</div>
        <div>
          <p v-if="isPrint" class="print-input">{{ form.사업자등록번호 }}</p>
          <ml-input v-else class="w-full" v-model="form.사업자등록번호" :readonly="board.readonly" />
        </div>
      </div>
      <div>
        <div>대표자</div>
        <div>
          <p v-if="isPrint" class="print-input">{{ form.대표자 }}</p>
          <ml-input v-else class="w-full" v-model="form.대표자" :readonly="board.readonly" />
        </div>
      </div>
      <div>
        <div>연락처</div>
        <div>
          <p v-if="isPrint" class="print-input">{{ form.연락처 }}</p>
          <ml-input v-else class="w-full" v-model="form.연락처" :readonly="board.readonly" />
        </div>
      </div>
      <div>
        <div>소재지</div>
        <div>
          <p v-if="isPrint" class="print-input">{{ form.소재지 }}</p>
          <ml-input v-else class="w-full" v-model="form.소재지" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 추진목표 및 기본방침 -->
    <div class="my-4">
      <div>
        <h5><i class="dot"></i>추진목표 및 기본방침</h5>
      </div>
    </div>
    <div class="writeGridContainer">
      <div class="writeGridLineItem">
        <div>추진목표</div>
        <div>
          <p v-if="isPrint" class="print-textarea">{{ form.추진목표 }}</p>
          <ml-textarea v-else v-model="form.추진목표" rows="5" class="w-full" />
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>기본방침</div>
        <div>
          <p v-if="isPrint" class="print-textarea">{{ form.기본방침 }}</p>
          <ml-textarea v-else v-model="form.기본방침" rows="5" class="w-full" />
        </div>
      </div>
    </div>

    <!-- 산업재해율 및 예방활동 계획 -->
    <div class="my-4">
      <div>
        <h5><i class="dot"></i>산업재해율 및 예방활동 계획</h5>
      </div>
    </div>
    <div class="writeGridContainer">
      <div class="writeGridLineItem">
        <div>최근 3년 동안 산업 재해율</div>
        <div>
          <p v-if="isPrint" class="print-textarea">{{ form.산업재해율 }}</p>
          <ml-textarea v-else v-model="form.산업재해율" rows="5" class="w-full" />
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>재해예방 활동 계획</div>
        <div>
          <p v-if="isPrint" class="print-textarea">{{ form.재해예방활동계획 }}</p>
          <ml-textarea v-else v-model="form.재해예방활동계획" rows="5" class="w-full" />
        </div>
      </div>
    </div>

    <!-- 작업 개요 -->
    <div class="my-4">
      <div>
        <h5><i class="dot"></i>작업 개요</h5>
      </div>
    </div>
    <div class="writeGridContainer">
      <div>
        <div>용역명</div>
        <div>
          <p v-if="isPrint" class="print-input">{{ form.용역명 }}</p>
          <ml-input v-else class="w-full" v-model="form.용역명" :readonly="board.readonly" />
        </div>
      </div>
      <div>
        <div>기간</div>
        <div>
          <p v-if="isPrint" class="print-input">{{ form.기간.sDate ? form.기간.sDate : "" }} ~ {{ form.기간.eDate ? form.기간.eDate : "" }}</p>
          <date-selector-rang v-else class="w-full" v-model="form.기간" :readonly="board.readonly" />
        </div>
      </div>
      <div>
        <div>장소</div>
        <div>
          <p v-if="isPrint" class="print-input">{{ form.장소 }}</p>
          <ml-input v-else class="w-full" v-model="form.장소" :readonly="board.readonly" />
        </div>
      </div>

      <div class="writeGridLineItem">
        <div>용역내용</div>
        <div>
          <p v-if="isPrint" class="print-textarea">{{ form.용역내용 }}</p>
          <ml-textarea v-else v-model="form.용역내용" rows="5" class="w-full" />
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>구성원 및 역할</div>
        <div>
          <p v-if="isPrint" class="print-textarea">{{ form.구성원및역할 }}</p>
          <ml-textarea v-else v-model="form.구성원및역할" rows="5" class="w-full" />
        </div>
      </div>
      <div class="writeGridLineItem">
        <div>안전조치사항</div>
        <div>
          <p v-if="isPrint" class="print-textarea">{{ form.안전조치사항 }}</p>
          <ml-textarea v-else v-model="form.안전조치사항" rows="5" class="w-full" />
        </div>
      </div>
    </div>

    <!-- 조직도 -->
    <div class="mt-4">
      <div>
        <h5><i class="dot"></i>조직도 및 비상연락망</h5>
      </div>
    </div>
    <table-organogram v-model="form.organogram" :readonly="board.readonly" :is-print="isPrint" title="- 조직도" :is-dot="false" />

    <table>
      <colgroup>
        <col width="240" />
        <col />
        <col />
      </colgroup>
      <thead>
        <tr v-for="(data, dataIndex) in form.비상연락망" :key="`${data.key}_${dataIndex}`">
          <th>{{ data.key }}</th>
          <td>
            <p v-if="isPrint" class="print-input">{{ data.name }}</p>
            <ml-input v-else class="w-full" v-model="data.name" :readonly="board.readonly" :placeholder="data.namePlaceholder" />
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ data.phone }}</p>
            <ml-input v-else class="w-full" v-model="data.phone" :readonly="board.readonly" :placeholder="data.phonePlaceholder" />
          </td>
        </tr>
      </thead>
    </table>

    <!-- 계획 8종 -->
    <div v-for="(item, itemIndex) in form.계획" :key="`${item.label}_${itemIndex}`" class="mt-8">
      <div class="my-4">
        <div>
          <h5><i class="dot"></i>{{ item.label }}</h5>
        </div>
      </div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>목적</div>
          <div>
            <p v-if="isPrint" class="print-input">{{ item.목적 }}</p>
            <ml-input v-else class="w-full" v-model="item.목적" :readonly="board.readonly" />
          </div>
        </div>
        <div class="writeGridLineItem">
          <div>대상</div>
          <div>
            <p v-if="isPrint" class="print-input">{{ item.대상 }}</p>
            <ml-input v-else class="w-full" v-model="item.대상" :readonly="board.readonly" />
          </div>
        </div>
        <div class="writeGridLineItem">
          <div>내용</div>
          <div>
            <p v-if="isPrint" class="print-textarea">{{ item.내용 }}</p>
            <ml-textarea v-else v-model="item.내용" rows="5" class="w-full" />
          </div>
        </div>
      </div>
    </div>

    <!-- 적격수급업체 선정 및 세부 평가 -->
    <table-score-grade
      class="mt-4"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :is-note="false"
      :is-not-dot-in-label="true"
      title="적격수급업체 선정 및 세부 평가"
      :list="form.scoreList"
      table-header-label="평가항목"
      table-header-content="평가기준"
      table-header-score="배점"
      @update-list-check="updateListCheck"
      @update-value="updateValue"
      :grade-value="gradeValue"
    />

    <!-- 평가등급 -->
    <div class="mt-8">
      <div>
        <h5>※ 평가등급</h5>
      </div>
    </div>
    <table class="mt-4">
      <colgroup>
        <col width="200" />
        <col width="400" />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th>등급</th>
          <th>득점</th>
          <th>등급</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in 평가등급">
          <td class="text-center" style="font-weight: 500">{{ item.grade }}</td>
          <td class="text-center" style="font-weight: 500">{{ item.score }}</td>
          <td>{{ item.description }}</td>
        </tr>
      </tbody>
    </table>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelectorRang from "../../../../components/selector/DateSelectorRang.vue";
import FieldSelector from "../../../../components/selector/FieldSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import TableOrganogram from "@/components/TableOrganogram.vue";
import TableScoreGrade from "@/components/TableScoreGrade.vue";

export default {
  components: {
    TableScoreGrade,
    TableOrganogram,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    TableCustom,
    FieldSelector,
    DateSelectorRang,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    gradeValue() {
      const score = this.form.score;

      if (score >= 90) {
        return "S";
      } else if (score >= 80) {
        return "A";
      } else if (score >= 70) {
        return "B";
      } else if (score >= 60) {
        return "C";
      } else {
        return "D";
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.writer) {
          if (!this.form.stdInfo.작성자 || this.form.stdInfo.작성자 === "") {
            const writerName = value.writer && value.writer.name ? value.writer.name : null;
            if (writerName) {
              this.form.stdInfo.작성자 = writerName;
            }
          }
        }
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        회사명: "",
        사업자등록번호: "",
        대표자: "",
        연락처: "",
        소재지: "",

        추진목표: "",
        기본방침: "",
        산업재해율: "",
        재해예방활동계획: "",
        용역명: "",
        기간: { sDate: "", eDate: "" },
        장소: "",
        용역내용: "",
        구성원및역할: "",
        안전조치사항: "",

        organogram: {
          organizations: [
            { lv: 1, name: "사업주", component: "label" },
            { lv: 2, name: "안전담당자", component: "edit-input" },
            { lv: 3, name: "반장", component: "edit-input" },
          ],
          data: [
            {
              name: "홍길동, 010-1234-5678",
              edit: false,
              showMenu: false,
              child: [
                {
                  name: "홍길동, 010-1234-5678",
                  edit: false,
                  showMenu: false,
                  child: [
                    {
                      name: "홍길동, 010-1234-5678",
                      edit: false,
                      showMenu: false,
                      child: [
                        {
                          name: "Level 4",
                          edit: false,
                          showMenu: false,
                          child: [
                            { name: "Level 5", edit: false, showMenu: false, child: [{ name: "Level 6", edit: false, showMenu: false, child: [{ name: "Level 7", edit: false, showMenu: false, child: [] }] }] },
                            { name: "Level 5", edit: false, showMenu: false, child: [{ name: "Level 6", edit: false, showMenu: false, child: [{ name: "Level 7", edit: false, showMenu: false, child: [] }] }] },
                          ],
                        },
                        {
                          name: "Level 4",
                          edit: false,
                          showMenu: false,
                          child: [
                            { name: "Level 5", edit: false, showMenu: false, child: [{ name: "Level 6", edit: false, showMenu: false, child: [{ name: "Level 7", edit: false, showMenu: false, child: [] }] }] },
                            { name: "Level 5", edit: false, showMenu: false, child: [{ name: "Level 6", edit: false, showMenu: false, child: [{ name: "Level 7", edit: false, showMenu: false, child: [] }] }] },
                          ],
                        },
                        {
                          name: "Level 4",
                          edit: false,
                          showMenu: false,
                          child: [
                            { name: "Level 5", edit: false, showMenu: false, child: [{ name: "Level 6", edit: false, showMenu: false, child: [{ name: "Level 7", edit: false, showMenu: false, child: [] }] }] },
                            { name: "Level 5", edit: false, showMenu: false, child: [{ name: "Level 6", edit: false, showMenu: false, child: [{ name: "Level 7", edit: false, showMenu: false, child: [] }] }] },
                          ],
                        },
                      ],
                    },
                    { name: "홍길동, 010-1234-5678", edit: false, showMenu: false },
                    { name: "홍길동, 010-1234-5678", edit: false, showMenu: false },
                  ],
                },
              ],
            },
          ],
        },
        비상연락망: [
          { key: "소방서", name: "", namePlaceholder: "○○○○ 소방서", phone: "", phonePlaceholder: "02-1234-5678" },
          { key: "보건소", name: "", namePlaceholder: "○○○○ 보건소", phone: "", phonePlaceholder: "02-1234-5678" },
          { key: "지역병원", name: "", namePlaceholder: "○○○○ 병원", phone: "", phonePlaceholder: "02-1234-5678" },
        ],
        계획: [
          { label: "비상사태 대비 체계 구축", 목적: "", 대상: "", 내용: "" },
          { label: "위험성평가 및 개선 계획", 목적: "", 대상: "", 내용: "" },
          { label: "구성원 의견 수렴 계획", 목적: "", 대상: "", 내용: "" },
          { label: "위험작업 관리계획", 목적: "", 대상: "작업허가서 발급/ 작업계획서 작성/ 위험 기계·기구 사용작업 등", 내용: "" },
          { label: "작업관련 실적, 작업자 이력·자격·경력 현황", 목적: "", 대상: "", 내용: "" },
          { label: "산업안전보건 관리비 편성 및 집행 계획", 목적: "", 대상: "안전보건교육/개인보호구/구급함/긴급 보수비용 등", 내용: "" },
          { label: "안전점검 및 모니터링 계획", 목적: "", 대상: "", 내용: "" },
          { label: "안전보건교육 계획", 목적: "", 대상: "", 내용: "" },
        ],
        score: 0,
        scoreList: [
          {
            id: 1,
            title: "※ 안전보건관리체제(20점)",
            label: "1. 일반원칙(5점)",
            content: "도급·수급인의 안전보건방침 적정 여부\n" + "- 안전보건방침 제출",
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: "",
            is_checked: "",
            titleColor: "#f9f9f9",
          },
          {
            id: 2,
            title: "※ 안전보건관리체제(20점)",
            label: "2. 계획수립(10점)",
            content: "산업재해예방 활동에 대한 수급인의 이행계획 적정 여부\n" + "- 안전보건관리계획서 제출",
            score: 10,
            good: 10,
            normal: 5,
            bad: 1,
            note: "",
            is_checked: "",
            titleColor: "#f9f9f9",
          },
          {
            id: 3,
            title: "※ 안전보건관리체제(20점)",
            label: "3. 역할 및 책임(5점)",
            content: "이행계획 추진을 위한 구성원의 역할 분담(본사, 현장)\n" + "- 안전보건관리 인력 및 조직편성, 관리감독자 지정 등",
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: "",
            is_checked: "",
            titleColor: "#f9f9f9",
          },
          {
            id: 4,
            title: "※ 실행수준(40점)",
            label: "4. 위험성평가(5점)",
            content: "도급업체에서 제공한 도급작업의 위험성평가 결과에 대한 이해수준 및 자체 유해·위험요인 평가 수준",
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: "",
            is_checked: "",
            titleColor: "#f9f9f9",
          },
          {
            id: 5,
            title: "※ 실행수준(40점)",
            label: "5. 안전점검(10점)",
            content: "안전점검 및 모니터링(보호구 착용확인 포함)",
            score: 10,
            good: 10,
            normal: 5,
            bad: 1,
            note: "",
            is_checked: "",
            titleColor: "#f9f9f9",
          },
          {
            id: 6,
            title: "※ 실행수준(40점)",
            label: "6. 이행확인(10점)",
            content: "점검결과 개선사항에 대한 안전조치 이행 여부 확인 절차\n" + "(도급업체의 지도조언에 대한 이행 및 확인포함)",
            score: 10,
            good: 10,
            normal: 5,
            bad: 1,
            note: "",
            is_checked: "",
            titleColor: "#f9f9f9",
          },
          {
            id: 7,
            title: "※ 실행수준(40점)",
            label: "7. 교육 및 기록(5점)",
            content: "안전보건교육 계획 및 기록관리",
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: "",
            is_checked: "",
            titleColor: "#f9f9f9",
          },
          {
            id: 8,
            title: "※ 실행수준(40점)",
            label: "8. 안전작업허가(10점)",
            content: "유해·위험작업에 대한 안전작업허가 및 관리자 배치계획",
            score: 10,
            good: 10,
            normal: 5,
            bad: 1,
            note: "",
            is_checked: "",
            titleColor: "#f9f9f9",
          },
          {
            id: 9,
            title: "※ 운영관리(20점)",
            label: "9. 신호 및 연락체계(5점)",
            content: "도급·수급업체간 신호 및 연락체계",
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: "",
            is_checked: "",
            titleColor: "#f9f9f9",
          },
          {
            id: 10,
            title: "※ 운영관리(20점)",
            label: "10. 위험물질 및 설비(10점)",
            content: "유해‧위험물질 및 취급 기계기구‧설비의 안전성 확인",
            score: 10,
            good: 10,
            normal: 5,
            bad: 1,
            note: "",
            is_checked: "",
            titleColor: "#f9f9f9",
          },
          {
            id: 11,
            title: "※ 운영관리(20점)",
            label: "11. 비상대책(5점)",
            content: "비상시 대피 및 피해 최소화 대책 (고용노동부, 소방서, 병원 포함)",
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: "",
            is_checked: "",
            titleColor: "#f9f9f9",
          },
          {
            id: 12,
            title: "※ 재해발생 수준(20점)",
            label: "12. 산업재해 현황",
            content: "최근 3년간 산업재해 발생 현황",
            score: 20,
            good: 20,
            normal: 10,
            bad: 1,
            note: "",
            is_checked: "",
            titleColor: "#f9f9f9",
          },
        ],
      },
      평가등급: [
        { grade: "S", score: "90점 이상", description: "도급작업을 안전하게 수행할 역량이 우수함" },
        { grade: "A", score: "80점 이상", description: "도급작업을 안전하게 수행할 기본적인 역량을 갖춤" },
        { grade: "B", score: "70점 이상", description: "도급작업을 수행할 안전보건관리 역량이 보통임" },
        { grade: "C", score: "60점 이상", description: "도급작업을 수행할 안전보건관리 역량이 부족함" },
        { grade: "D", score: "60점 미만", description: "도급작업을 수행할 안전보건관리 역량이 매우 낮음" },
      ],
    };
  },
  methods: {
    updateListCheck(indexList, text) {
      this.form.scoreList[indexList].is_checked = text;
    },
    updateValue(value) {
      this.form.score = value;
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    th,
    td {
      font-size: 14px;
      font-weight: 500;

      border: 1px solid #cdcdcd;
    }

    th {
      text-align: center;
      background: #f9f9f9;
      padding: 10px;
    }

    td {
      text-align: start;
      padding: 5px;
    }
  }
  tbody {
    th {
      font-size: 14px;
      font-weight: 500;

      text-align: start;
      padding: 5px;
    }

    td {
      padding: 10px 15px;
    }

    th,
    td {
      border: 1px solid #cdcdcd;
    }
  }
}
</style>
